import { Injectable, inject } from '@angular/core';
import { AuthActions, AuthService } from '@interacta-shared/data-access-auth';
import { GoogleAnalyticsService } from '@interacta-shared/data-access-common';
import { StateManagerService } from '@modules/state/services/state-manager.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { map, tap } from 'rxjs/operators';
import { SystemMessageService } from '../services/system-message.service';
import { fetchUserCapabilities } from './user-capabilities/user-capabilities.actions';

@Injectable()
export class AppEffects {
    private actions = inject(Actions);
    private authService = inject(AuthService);
    private stateManagerService = inject(StateManagerService);
    private googleAnalyticsService = inject(GoogleAnalyticsService);
    private systemMessageService = inject(SystemMessageService);

    afterLogin$ = createEffect(() =>
        this.actions.pipe(
            ofType(AuthActions.login),
            tap(() => {
                this.stateManagerService.initialize();
                this.googleAnalyticsService.setUserProperties(
                    this.authService.currentUserData(),
                );
                this.systemMessageService.fetchMessages();
            }),
            map(() => fetchUserCapabilities()),
        ),
    );

    afterLogout$ = createEffect(
        () =>
            this.actions.pipe(
                ofType(AuthActions.logout),
                tap(() => {
                    this.stateManagerService.flush();
                    this.googleAnalyticsService.setUserProperties(null);
                }),
            ),
        { dispatch: false },
    );

    resetFocus$ = createEffect(
        () =>
            this.actions.pipe(
                ofType(routerNavigatedAction),
                tap((action) => {
                    const isModalOpen = !!document.querySelector(
                        '[aria-modal="true"]',
                    );
                    // A tab whose panels are routes navigates on every
                    // activation: blurring there would take the focus off the
                    // tab strip, and the arrows would stop reaching the tabs.
                    const isTabActivation =
                        !!document.activeElement?.closest('[role="tablist"]');

                    if (
                        !isModalOpen &&
                        !isTabActivation &&
                        !action.payload.event.url.includes('#') &&
                        document.activeElement instanceof HTMLElement
                    ) {
                        document.activeElement.blur();
                        document.body.focus();
                    }
                }),
            ),
        { dispatch: false },
    );
}
